import { hc } from 'hono/client';
import type { AppType } from '@repo/api';
import { siblingAppUrl } from '@repo/ui';
import { getAccessToken } from './auth';

// Derive the API origin by subdomain swap (editor.<host> → api.<host>); on dev
// fall back to VITE_API_URL or the local API port.
export const API_BASE_URL = siblingAppUrl(
  'api',
  import.meta.env.VITE_API_URL || 'http://localhost:8787'
);

/** Attaches the streamer JWT to every API call. */
const authFetch: typeof globalThis.fetch = (input, init) => {
  const token = getAccessToken();
  const headers = new Headers(init?.headers);
  if (token) headers.set('Authorization', `Bearer ${token}`);
  return fetch(input, { ...init, headers });
};

/** Typed RPC client — routes/response types inferred from the API's AppType. */
export const client = hc<AppType>(API_BASE_URL, { fetch: authFetch });
